import "@sentry/browser";
import angular from "angular";


import 'angular-chart.js';
import 'angular-cookies';
import 'angular-dynamic-locale';
import 'angular-material';
import 'angular-material-data-table';
import 'angular-material-time-picker';
import 'angular-messages';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-translate-once';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'angular-ui-sortable';
import 'angular-uuid';
import 'core-js/shim';
import 'jquery-ui/ui/widgets/sortable'; // needed for angular-ui-sortable above.
import 'md-date-range-picker';
import 'url-polyfill';
import 'url-search-params-polyfill';
import { sentryRun } from './config/sentry.run.js';

sentryRun();

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { downgradeComponent, downgradeInjectable, downgradeModule } from '@angular/upgrade/static';
import { TranslateService } from '@ngx-translate/core';
import { ɵa as NgxTweetComponent } from 'ngx-tweet';

import { MatDialog } from '@angular/material/dialog';
import { ScenarioWizardComponent } from 'src/app/care/scenarios/scenario-wizard/scenario-wizard.component';
import { ChatBotWhatsappTemplateEditorComponent } from 'src/app/care/scenarios/social-networks/whatsapp/chat-bot-whatsapp-template-editor/chat-bot-whatsapp-template-editor.component';
import { SelectWhatsappTemplateComponent } from 'src/app/care/scenarios/social-networks/whatsapp/select-whatsapp-template/select-whatsapp-template.component';
import { AddBusinessManagerComponent } from 'src/app/catalogs/add-business-manager/add-business-manager.component';
import { AddCatalogComponent } from 'src/app/catalogs/add-catalog/add-catalog.component';
import { CatalogsMainComponent } from 'src/app/catalogs/catalogs-main/catalogs-main.component';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { TrackService } from 'src/app/core/track/track.service';
import { WebSocketService } from 'src/app/core/websocket/websocket.service';
import { CustomFieldsService } from 'src/app/custom-fields/custom-fields.service';
import { DialogContainerForAjsComponent } from 'src/app/marketing/mass-messaging/creation-edition-dialog/dialog-container-for-ajs/dialog-container-for-ajs.component';
import { MetricsDialogContainerForAjsComponent } from 'src/app/metrics/shared/components/report-edition-dialog/metrics-dialog-container-for-ajs/metrics-dialog-container-for-ajs.component';
import { SitesService } from 'src/app/mobile/shared/sites.service.ts';
import { FinalizeAddAccountComponent } from 'src/app/parameters/add-account/finalize-add-account/finalize-add-account.component';
import { GoogleBusinessProfileLocationsComponent } from 'src/app/parameters/add-account/google-business-profile/google-business-profile-locations/google-business-profile-locations.component';
import { WhatsappAccountVonageComponent } from 'src/app/parameters/add-account/whatsapp-account-vonage/whatsapp-account-vonage.component';
import { SendByEmailSettingsComponent } from 'src/app/parameters/company-contacts/send-by-email-settings/send-by-email-settings.component';
import { WhatsappTemplatesService } from 'src/app/parameters/message-templates/whatsapp-templates/whatsapp-templates.service';
import { SessionsComponent } from 'src/app/parameters/sessions/sessions/sessions.component';
import { RandomDispatchActionComponent } from 'src/app/parameters/triage/random-dispatch-action/random-dispatch-action.component';
import { RandomDispatchActionReadOnlyComponent } from 'src/app/parameters/triage/random-dispatch-action/read-only/random-dispatch-action-read-only.component';
import { UsersPermissionsComponent } from 'src/app/parameters/users/users-permissions/users-permissions.component';
import { UsersService } from 'src/app/parameters/users/users.service';
import { RolesForUserComponent } from 'src/app/parameters/users/users/user-edition/roles-for-user/roles-for-user.component';
import { EmojisListComponent } from 'src/app/shared/components/emojis/emojis-list.component';
import { ErrorsPlaceholderCellComponent } from 'src/app/shared/components/errors-placeholder-cell/errors-placeholder-cell.component';
import { MessageEditorWrapperComponent } from 'src/app/shared/components/message-editor-wrapper/message-editor-wrapper.component';
import { PermissionsPerSiteComponent } from 'src/app/shared/components/permissions-per-site/permissions-per-site.component';
import { SatisfactionSurveyDuplicateComponent } from 'src/app/shared/components/satisfaction-surveys/satisfaction-survey-duplicate/satisfaction-survey-duplicate.component';
import { SelectHierarchicalComponent } from 'src/app/shared/components/select-hierarchical/select-hierarchical.component';
import { SelectComponent } from 'src/app/shared/components/select/select.component';
import { HunspellService } from 'src/app/shared/components/single-message-editor/codemirror-spellchecker/hunspell.service';
import { SiteIconAndNameComponent } from 'src/app/shared/components/site-icon-and-name/site-icon-and-name.component';
import { BasicService } from 'src/app/shared/services/basic.service';
import { MaintenanceModeService } from 'src/app/shared/services/maintenance-mode.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { StringSearchService } from 'src/app/shared/services/string-search.service';
import { TimezoneService } from 'src/app/shared/services/timezone.service';
import { DesktopTPPRightColumnComponent } from 'src/app/task-process/desktop-tpp-right-column/desktop-tpp-right-column.component';
import { TaskProcessService } from 'src/app/task-process/shared/task-process.service';
import { TaskProcessPageComponent } from 'src/app/task-process/task-process-page.component';
import { CrmOrganizationsLinkedComponent } from 'src/app/user-profile/shared/crm-organizations-linked/crm-organizations-linked.component';

import { AdminFrontModule } from '../admin-front/admin-front.module';
import { AngularBootstrapComponent } from '../admin-front/angular-bootstrap.component';

import { environment } from '../environments/environment';
import { } from './components/audience/audience.module.js';
import { } from './components/confirmation/confirmation.js';
import { } from './components/core/core.module.js';
import { } from './components/editor2/editor2.module.js';
import { } from './components/emoji-picker/emojiPicker.module.js';
import { } from './components/error/error.module.js';
import { } from './components/favorites-editor/favorites.module.js';
import { } from './components/login/login.module.js';
import { } from './components/mass-messaging/mass-messaging.module.js';
import { } from './components/messages/messages.module.js';
import { } from './components/metrics/metrics.module.js';
import { } from './components/notifications/notifications.controller.js';
import { } from './components/notifications/notifications.service.js';
import { } from './components/parameters/accounts/accounts.module.js';
import { } from './components/parameters/add-account/add-account.module.js';
import { } from './components/parameters/add-meta-business-manager-list/addMetaBusinessManagerList.module.js';
import { } from './components/parameters/add-meta-catalog-list/addMetaCatalogList.module.js';
import { } from './components/parameters/addAccountBusinessChat/addAccountBusinessChat.module.js';
import { } from './components/parameters/addAccountFb/addAccountFb.module.js';
import { } from './components/parameters/addAccountFbOld/addAccountFb.module.js';
import { } from './components/parameters/addAccountGmb/addAccountGMB.module.js';
import { } from './components/parameters/addAccountKakaotalk/addAccountKakaotalk.module.js';
import { } from './components/parameters/addAccountLine/addAccountLine.module.js';
import { } from './components/parameters/addAccountLineMulesoft/addAccountLineMulesoft.module.js';
import { } from './components/parameters/addAccountLinkedin/addAccountLinkedin.module.js';
import { } from './components/parameters/addAccountTrustpilot/addAccountTrustpilot.module.js';
import { } from './components/parameters/addAccountWebchat/addAccountWebchat.module.js';
import { } from './components/parameters/addAccountWhatsapp/addAccountWhatsapp.module.js';
import { } from './components/parameters/addAccountWhatsappVia360D/addAccountWhatsappVia360D.module.js';
import { } from './components/parameters/applications/applications.module';
import { } from './components/parameters/business-hours/business-hours.module.js';
import { } from './components/parameters/catalogs/catalogs.module.js';
import { } from './components/parameters/company-contacts/company-contacts.module.js';
import { } from './components/parameters/crm/crm.module.js';
import { } from './components/parameters/crm/salesforce/salesforce.module.js';
import { } from './components/parameters/crm/zendesk/zendesk.module.js';
import { } from './components/parameters/custom-field/custom-field.module.js';
import { } from './components/parameters/priority-rules/priority-rules.module.js';
import { } from './components/parameters/quick-replies/quick-replies.module.js';
import { } from './components/parameters/reports/reports.module.js';
import { } from './components/parameters/satisfaction-surveys/satisfaction-surveys.module.js';
import { } from './components/parameters/sftp-exports/sftp-exports.module.js';
import { } from './components/parameters/sftp-servers/sftp-servers.module.js';
import { } from './components/parameters/shared/parameters-shared.module.js';
import { } from './components/parameters/site-groups/site-group.module.js';
import { } from './components/parameters/tags/parameters.tags.module.js';
import { } from './components/parameters/triage/triage.module';
import { } from './components/parameters/users/users.module.js';
import { } from './components/password-confirm/password-confirm.module.js';
import { } from './components/preferences/preferences.service.js';
import { } from './components/publications/publications.module.js';
import { } from './components/saml-error/saml-error.module.js';
import { } from './components/search/search.module.js';
import { } from './components/segments/segments.module.js';
import { } from './components/tasks/pushbox/pushbox.module.js';
import { } from './components/tasks/tasks-services.js';
import { } from './components/tasks/tasks.module.js';
import { } from './components/user/user.module.js';
import { } from './components/users-roles/users-roles.module.js';
import { } from './components/verbatim/verbatim.module.js';
import { appReloadRun } from './config/app-reload.run';
import { browserDetectRun } from './config/browser-detect.run';
import { clearCookiesRun } from './config/clear-cookies.run';
import { httpInterceptorsConfig } from './config/http-interceptors.config';
import { jointjsHacksRun } from './config/jointjs-hacks.run';
import { materialColorsConfig } from './config/material-colors.config';
import { materialDateFormatRun } from './config/material-date-format.run';
import { miscConfig } from './config/misc.config';
import { pushModeUrlConverterRun } from './config/push-mode-url-converter.run';
import { reloadLatestClientRun } from './config/reload-latest-client.run';
import { routerConfig } from './config/router.config';
import { sachaRun } from './config/sacha.run';
import { sceDelegateProvider } from './config/sce-delegate-provider.config';
import { scrollToTaskIdRun } from './config/scroll-to-task-id.run';
import { stateChangeStartRun } from './config/state-change-start.run';
import { trackerSetupConfig } from './config/tracker-setup.config';
import { trackerSetupRun } from './config/tracker-setup.run';
import { v3v4CssClassRun } from './config/v3-v4-css-class.run';
import { } from './directives/app.directives.js';
import { } from './directives/scroll.directives.js';
import { } from './filters/app.filters.js';
import { } from './services/services.module.js';
import { } from './strategies/strategies.module.js';

import {
  addAccountStates,
  alcmeonAiStates,
  audienceStates,
  crmOrganizationsStates,
  customEventsStates,
  engagementStates,
  externalAuthorizationStates,
  inMessageStates,
  inboxStates,
  linkShortenerStates,
  massMessagingStates,
  messageTemplatesStates,
  metricsStates,
  optinsStates,
  pushboxStates,
  quickRepliesStates,
  searchStates,
  trackLinkLabelsStates,
  userPreferencesStates,
  whatsappCloudApiStates
} from 'src/app/shared/states';


if (environment.production) {
  enableProdMode();
}

const bootstrapFn = (extraProviders) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AdminFrontModule);
};

// Downgrade the Angular module to an AngularJS module.
const downgradedAdminFrontModule = downgradeModule(bootstrapFn);

export const downgradedAngularModule = angular.module('downgradedAngularModule', [downgradedAdminFrontModule])
  // Components.
  .directive('angularNgxTweet', downgradeComponent({ component: NgxTweetComponent }))
  .directive('angularTaskProcessPage', downgradeComponent({ component: TaskProcessPageComponent }))
  .directive('angularCatalogsMain', downgradeComponent({ component: CatalogsMainComponent }))
  .directive('angularAddBusinessManager', downgradeComponent({ component: AddBusinessManagerComponent }))
  .directive('angularAddCatalog', downgradeComponent({ component: AddCatalogComponent }))
  .directive('angularDesktopTppRightColumn', downgradeComponent({ component: DesktopTPPRightColumnComponent }))
  .directive('angularEmojisList', downgradeComponent({ component: EmojisListComponent }))
  .directive('angularBootstrap', downgradeComponent({ component: AngularBootstrapComponent }))
  .directive('angularMessageEditor', downgradeComponent({ component: MessageEditorWrapperComponent }))
  .directive('angularWhatsappAccountVonage', downgradeComponent({ component: WhatsappAccountVonageComponent }))
  .directive('angularChatBotWhatsappTemplateEditor', downgradeComponent({ component: ChatBotWhatsappTemplateEditorComponent }))
  .directive('appSelectWhatsappTemplate', downgradeComponent({ component: SelectWhatsappTemplateComponent }))
  .directive('angularGoogleBusinessProfileLocations', downgradeComponent({ component: GoogleBusinessProfileLocationsComponent }))
  .directive('angularSessions', downgradeComponent({ component: SessionsComponent }))
  .directive('angularSelect', downgradeComponent({ component: SelectComponent }))
  .directive('angularSelectHierarchical', downgradeComponent({ component: SelectHierarchicalComponent }))
  .directive('angularSiteIconAndName', downgradeComponent({ component: SiteIconAndNameComponent }))
  .directive('angularCrmOrganizationsLinked', downgradeComponent({ component: CrmOrganizationsLinkedComponent }))
  .directive('angularUsersPermissions', downgradeComponent({ component: UsersPermissionsComponent }))
  .directive('angularPermissionsPerSite', downgradeComponent({ component: PermissionsPerSiteComponent }))
  .directive('angularSendByEmailSettings', downgradeComponent({ component: SendByEmailSettingsComponent }))
  .directive('angularRandomDispatchAction', downgradeComponent({ component: RandomDispatchActionComponent }))
  .directive('angularRandomDispatchActionReadOnly', downgradeComponent({ component: RandomDispatchActionReadOnlyComponent }))
  .directive('angularErrorsPlaceholderCell', downgradeComponent({ component: ErrorsPlaceholderCellComponent }))
  .directive('angularDialogContainerForAjs', downgradeComponent({ component: DialogContainerForAjsComponent }))
  .directive('angularSatisfactionSurveyDuplicate', downgradeComponent({ component: SatisfactionSurveyDuplicateComponent }))
  .directive('angularScenarioWizard', downgradeComponent({ component: ScenarioWizardComponent }))
  .directive('angularFinalizeAddAccount', downgradeComponent({ component: FinalizeAddAccountComponent }))
  .directive('angularRolesForUser', downgradeComponent({ component: RolesForUserComponent }))
  .directive('angularMetricsDialogContainerForAjs', downgradeComponent({ component: MetricsDialogContainerForAjsComponent }))

  // Services.
  .factory('AngularTranslateService', downgradeInjectable(TranslateService))
  .factory('AngularAlcmeonContextService', downgradeInjectable(AlcmeonContextService))
  .factory('AngularTimezoneService', downgradeInjectable(TimezoneService))
  .factory('AngularTaskProcessService', downgradeInjectable(TaskProcessService))
  .factory('AngularWebSocketService', downgradeInjectable(WebSocketService))
  .factory('AngularHunspellService', downgradeInjectable(HunspellService))
  .factory('AngularMaintenanceModeService', downgradeInjectable(MaintenanceModeService))
  .factory('AngularTrackService', downgradeInjectable(TrackService))
  .factory('AngularCustomFieldsService', downgradeInjectable(CustomFieldsService))
  .factory('AngularStringSearchService', downgradeInjectable(StringSearchService))
  .factory('AngularSitesService', downgradeInjectable(SitesService))
  .factory('AngularWhatsappTemplatesService', downgradeInjectable(WhatsappTemplatesService))
  .factory('AngularSpinnerService', downgradeInjectable(SpinnerService))
  .factory('AngularAsyncRequestService', downgradeInjectable(AsyncRequestService))
  .factory('AngularUsersService', downgradeInjectable(UsersService))
  .factory('AngularBasicService', downgradeInjectable(BasicService))
  .factory('AngularMatDialog', downgradeInjectable(MatDialog))
  ;

require('src/app/shared/components/components.downgrade');

// Module Parameters.
require('src/app/parameters/add-account/add-account.downgrade');
require('src/app/parameters/add-account/whatsapp-cloud-api/whatsapp-cloud-api.downgrade')
require('src/app/parameters/crm-organizations/crm-organizations.downgrade');
require('src/app/parameters/in-message/in-message.downgrade');
require('src/app/parameters/link-shortener/link-shortener.downgrade');
require('src/app/parameters/users/users.downgrade');
require('src/app/user-preferences/user-preferences.downgrade');
require('src/app/mobile/shared/user/user.downgrade');
require('src/app/parameters/external-authorizations/external-authorizations.downgrade');
require('src/app/parameters/alcmeon-ai/alcmeon-ai.downgrade');
require('src/app/parameters/custom-events/custom-events.downgrade');
require('src/app/parameters/track-link-labels/track-link-labels.downgrade');
require('src/app/parameters/accounts/accounts.downgrade');
require('src/app/parameters/message-templates/message-templates.downgrade')

// Module Care.
require('src/app/care/inbox/inbox.downgrade');
require('src/app/care/engagement/engagement.downgrade');
require('src/app/care/search/search.downgrade');
require('src/app/care/publications/publications.downgrade');
require('src/app/care/pushbox/pushbox.downgrade');
require('src/app/care/quick-replies/quick-replies.downgrade');
require('src/app/care/scenarios/quick-replies-commons/ai-connector/ai-connector.downgrade');
require('src/app/care/scenarios/quick-replies-commons/api-connector/api-connector.downgrade');
require('src/app/care/scenarios/quick-replies-commons/recurring-notif/recurring-notif.downgrade');
require('src/app/care/scenarios/quick-replies-commons/note/note.downgrade');

// Module Marketing.
require('src/app/marketing/audience/audience.downgrade');
require('src/app/marketing/mass-messaging/mass-messaging.downgrade');
require('src/app/marketing/optins/optins.downgrade');

// Module Metrics
require('src/app/metrics/metrics.downgrade');

export const appModule = angular.module('AlcmeonApp', [
  'ngSentry',

  // 3rd party modules
  'ui.sortable',
  'ui.bootstrap',
  'ui.router',
  'pascalprecht.translate',
  'tmh.dynamicLocale',
  'ngAnimate',
  'ngMaterial',
  'ngMessages',
  'ngCookies',
  'ngSanitize',
  'ngMaterialDateRangePicker',
  'md.time.picker',
  'md.data.table',
  'angular-uuid',

  // 1st party modules
  'downgradedAngularModule',
  'core',
  'confirmation',
  'error',
  'editor2',
  'notifications.service',
  'notifications.controller',
  'user',
  'app.directives',
  'app.scroll-directives',
  'app.filters',
  'app.services',
  'messages',
  'tasks',
  'pushbox',
  'tasks.services',
  'search',
  'strategies',
  'preferences.service',
  'parameters.shared',
  'parameters.sftp-servers',
  'parameters.priority-rules',
  'parameters.triage',
  'parameters.business-hours',
  'parameters.sftp-exports',
  'parameters.tags',
  'parameters.satisfaction-surveys',
  'parameters.quick-replies',
  'parameters.custom-field',
  'parameters.reports',
  'parameters.users',
  'parameters.add-account',
  'parameters.crm',
  'parameters.salesforce',
  'parameters.zendesk',
  'parameters.accounts',
  'parameters.catalogs',
  'parameters.addAccountTrustpilot',
  'parameters.addAccountFbOld',
  'parameters.addAccountFb',
  'parameters.addAccountWebchat',
  'parameters.addAccountWhatsapp',
  'parameters.addAccountWhatsappVia360DRegister',
  'parameters.addAccountBusinessChat',
  'parameters.addAccountGmb',
  'parameters.addAccountLine',
  'parameters.addAccountLineMulesoft',
  'parameters.addAccountKakaotalk',
  'parameters.addAccountLinkedin',
  'parameters.addMetaBusinessManagerList',
  'parameters.addMetaCatalogList',
  'parameters.applications',
  'login.controller',
  'saml-error.controller',
  'password-confirm.controller',
  'metrics',
  'emoji-picker',
  'audience',
  'segments',
  'users-roles',
  'mass-messaging',
  'favorites',
  'verbatim',
  'parameters.company-contacts',
  'publication',
  'site-groups'
])
  .config(trackerSetupConfig)
  .run(trackerSetupRun)
  .config(materialColorsConfig)
  .config(miscConfig)
  .config(httpInterceptorsConfig)
  .config(routerConfig)
  .config(sceDelegateProvider)
  .run(sachaRun)
  .run(pushModeUrlConverterRun)
  .run(browserDetectRun)
  .run(v3v4CssClassRun)
  .run(scrollToTaskIdRun)
  .run(stateChangeStartRun)
  .run(reloadLatestClientRun)
  .run(appReloadRun)
  .run(clearCookiesRun)
  .run(materialDateFormatRun)
  .run(jointjsHacksRun)

  // The states per modules.

  // Module Metrics
  .config(metricsStates)

  // Module Parameters.
  .config(addAccountStates)
  .config(alcmeonAiStates)
  .config(customEventsStates)
  .config(crmOrganizationsStates)
  .config(externalAuthorizationStates)
  .config(inMessageStates)
  .config(linkShortenerStates)
  .config(userPreferencesStates)
  .config(whatsappCloudApiStates)
  .config(messageTemplatesStates)
  .config(trackLinkLabelsStates)
  // Module Care.
  .config(inboxStates)
  .config(engagementStates)
  .config(searchStates)
  .config(pushboxStates)
  .config(quickRepliesStates)
  // Module Marketing.
  .config(audienceStates)
  .config(optinsStates)
  .config(massMessagingStates)
  ;
